import { ChipColors } from './Chip';
import { Theme, css } from '@emotion/react';

const chipTheme = (colors: Theme['colors'], theme: ChipColors) => {
  switch (theme) {
    case 'default':
      return css`
        --chip-background-color: ${colors.backgroundLight};
        --chip-border-color: ${colors.borderLight};
        --chip-text-color: ${colors.textDark};
      `;

    case 'primary':
      return css`
        --chip-background-color: ${colors.backgroundPrimary};
        --chip-border-color: ${colors.borderPrimary};
        --chip-text-color: ${colors.textPrimary};
      `;

    case 'secondary':
      return css`
        --chip-background-color: ${colors.backgroundDark};
        --chip-border-color: ${colors.secondary};
        --chip-text-color: ${colors.textDark};
      `;

    case 'error':
      return css`
        --chip-background-color: ${colors.backgroundDanger};
        --chip-border-color: ${colors.danger};
        --chip-text-color: ${colors.textDanger};
      `;

    case 'info':
      return css`
        --chip-background-color: ${colors.backgroundPrimary};
        --chip-border-color: ${colors.primary};
        --chip-text-color: ${colors.textPrimary};
      `;

    case 'success':
      return css`
        --chip-background-color: ${colors.backgroundSuccess};
        --chip-border-color: ${colors.success};
        --chip-text-color: ${colors.textSuccess};
      `;

    case 'warning':
      return css`
        --chip-background-color: ${colors.backgroundWarning};
        --chip-border-color: ${colors.warning};
        --chip-text-color: ${colors.textWarning};
      `;

    case 'internal':
      return css`
        --chip-background-color: ${colors.backgroundInternal};
        --chip-border-color: ${colors.internal};
        --chip-text-color: ${colors.textInternal};
      `;
  }
};

export const chipBase =
  (color: ChipColors) =>
  ({ colors, font, typography }: Theme) => css`
    ${chipTheme(colors, color)}

    background-color: color-mix(in srgb, var(--chip-background-color), white 90%);
    border: 1px solid var(--chip-border-color);
    color: var(--chip-text-color);
    font-family: ${font.medium};

    .MuiChip-icon {
      color: var(--chip-text-color);
      font-size: ${typography.pxToRem(26)};
    }

    &.MuiChip-clickable:hover {
      background-color: color-mix(in srgb, var(--chip-background-color), white 80%);
    }

    &.MuiChip-outlined {
      background-color: transparent;
      color: ${colors.textBase};

      .MuiChip-icon {
        color: ${colors.textBase};
      }
    }
  `;
